import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query'
import { LeadDto } from 'api/Clients/Types/LeadDto'
import { WelcomeTradingAccountFilterKey } from 'api/Trading-Accounts/Types/WelcomeTradingAccountDto'
import { BuildQueryProps } from 'utils/QueryHelpers'

export const normalizeWelcomeTradingAccountsSearchQuery = (
  filter: FilterDescriptor[] | CompositeFilterDescriptor
): BuildQueryProps => {
  const gridFilterDescriptor = filter as CompositeFilterDescriptor
  const filters = gridFilterDescriptor.filters.map(
    (filterDescriptor: FilterDescriptor | CompositeFilterDescriptor) => {
      const filterItem = filterDescriptor as FilterDescriptor

      if (filterItem.field === WelcomeTradingAccountFilterKey.lead) {
        return {
          ...filterItem,
          value: filterItem?.value ? filterItem.value.map((x: LeadDto) => x.id) : filterItem.value,
        }
      }

      return filterItem
    }
  )

  return { ...gridFilterDescriptor, filters }
}
